module.exports = __webpack_public_path__ + "assets/ticket.906695a3.svg";